export default {
  admin: () => import("/vercel/path0/layouts/admin.vue"),
  "be-investor": () => import("/vercel/path0/layouts/be-investor.vue"),
  "create-account": () => import("/vercel/path0/layouts/create-account.vue"),
  default: () => import("/vercel/path0/layouts/default.vue"),
  "dual-color-container": () => import("/vercel/path0/layouts/dual-color-container.vue"),
  fdi: () => import("/vercel/path0/layouts/fdi.vue"),
  "register-account": () => import("/vercel/path0/layouts/register-account.vue")
}